module.exports = __webpack_public_path__ + "static/braveBrowser-bea3aa9cb343a2f0af34e8ee51f4d52c.gif";